var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 179,
    viewBox: "0 0 201 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 10",
    d: "M65.6577 77.7486L198.91 45.1943V177.22H65.6577V77.7486Z",
    fill: "#333232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 11",
    d: "M0 38.4771L129.185 14.3197L198.523 45.1946L65.8515 77.6198L0 38.4771Z",
    fill: "#2B2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 12",
    d: "M0 38.4771L65.6578 77.2322V178.512H0V38.4771Z",
    fill: "#4D4B4B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup7);
export default __webpack_public_path__ + "static/media/Group 7.da0be5edc6a9d7f766c3b0f43155162d.svg";
export { ForwardRef as ReactComponent };